<!--
 * @Email: rumosky@163.com
 * @Author: rumosky
 * @Github: https://github.com/rumosky
 * @Date: 2019-07-19 09:32:08
 * @Description: 封装分页组件
 -->
<template>
  <div>
    <el-pagination
    background
    layout="prev, pager, next"
    :page-size='limit'
    @current-change="pageOffset"
    :prev-text="$t('prevText')"
    :next-text="$t('nextText')"
    :total="num">
  </el-pagination>
  </div>
  
</template>

<script>
  export default {
    name: "pagination",
    props: {
      num: Number,
      limit: Number
    },
    methods: {
      pageOffset(i) {
        console.log(i);
        this.$emit('getNew', i);
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/page/pagination.vue